/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import { claimNeoRewardDetails, getNeoBrands, referralBalance } from "./MyReferralPage.api";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "context/auth-context";
import { useNavigate, useLocation, NavigateFunction } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay-ts";
import { Modal } from "antd";
import { FiArrowRight, FiShield } from "react-icons/fi";
import { useBonusPoints } from "hooks/useBonusPointsDetails";
import { bonusDetailsType } from "types/useCustomHookTypes";
import { useWalletDetails } from "hooks/useWalletDetails";
import Giftcard from "../../assets/SideBarIcons/Giftcard.png";
import { getIpAddress } from "components/JoinNowForm/getdata";
import { axiosClient } from "api/api";
import { RedeemBrandStep } from "./RedeemBrandStep";
import { RedeemDetailsStep } from "./RedeemDetailsStep";

const skipPointsValidationPanelList = ["509626", "517676", "521553", "513736", "521551", "513742"];
const intialState = {
  neoBrands: "",
  points: +"",
  email: "",
  mobile: "",
  studyData: "",
  service: "",
  requestType: "",
  studyDefaultPoints: +"",
  errors: {
    neoBrands: "",
    points: "",
    email: "",
    mobile: "",
  },
};
type ClaimDataType = typeof intialState;
type FormState = typeof intialState;
export const NeoBrandsData = () => {
  const { auth } = useAuth();
  const walletDetails: Record<string, number | undefined> = useWalletDetails();
  const bonusDetails: bonusDetailsType | null = useBonusPoints();
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const [showButton, setShowButton] = useState(true);
  const [country, setCountry] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [countryCode, setCountryCode] = useState<any>("US");
  const [formState, setFormState] = useState<FormState>(intialState);
  const [enabled, setEnabled] = React.useState<boolean>(false);
  const [isOtpConsentChecked, setIsOtpConsentChecked] = useState(false);
  const [ipAddressName, setIpAddressName] = useState("");
  const location = useLocation();
  const { redeem_point } = location.state || {};

  useEffect(() => { getIpAddress(setIpAddressName); }, []);
  useEffect(() => {
    if (walletDetails && bonusDetails) {
      if (!(walletDetails?.userWalletPoints >= Number(bonusDetails?.data?.target_points))) {
        navigate("/Dashboard");
      }
      setEnabled(walletDetails?.userWalletPoints >= Number(bonusDetails?.data?.target_points));
    }
  }, [walletDetails, bonusDetails]);

  const getNeoBrandsData = useQuery(["NeoBrands", country], () => getNeoBrands(), {
    refetchOnWindowFocus: false,
    enabled: !!country,
  });

  const PointDisplay = redeem_point;

  const getReferralBalanceBalance = useQuery(
    ["referralPoint"],
    () => referralBalance(auth.panelistId),
    {
      refetchOnWindowFocus: false,
    }
  );

  const postQuery = useMutation(
    ["claimNeoReward"],
    () =>
      claimNeoRewardDetails({
        neoBrands: formState.neoBrands,
        points: +PointDisplay ? +PointDisplay : formState.points,
        email: formState.email,
        mobile: formState.mobile.substring(1),
        panelistId: auth.panelistId,
        studyData: formState.studyData,
        service: formState.service,
        requestType: formState.requestType,
        currency: country,
        studyID: JSON.parse(localStorage.getItem("ApprovedStudyId") || "[]"),
        ipAddress: ipAddressName,
      }),
    {
      onSuccess(response: any) {
        if (response.success) {
          Modal.success({
            title: "Success!",
            content: response.message,
            onOk() {
              navigate("/otp", {
                state: {
                  requestId: response.id,
                  service: formState.requestType,
                  points: formState.points,
                },
              });
            },
          });
        } else {
          Modal.error({
            title: "Encountered an error!",
            content: response.message,
          });
        }
      },
      onError(error: any) {
        if (error && error.response?.data) {
          Modal.error({
            title: "Encountered an error!",
            content: error.response.data.message,
          });
        }
      },
    }
  );

  useEffect(() => {
    if (location.pathname.includes("/referral")) {
      setFormState({
        ...formState,
        ["service"]: "isZampliaSurveysReferralClaimRewardEnable",
        ["requestType"]: "Referral Wallet",
      });
    } else if (location.pathname.includes("/streak")) {
      setFormState({
        ...formState,
        ["service"]: "isZampliaSurveysStreakClaimRewardEnable",
        ["requestType"]: "Streak Wallet",
      });
    } else if (location.pathname.includes("/study")) {
      setFormState({
        ...formState,
        ["service"]: "isZampliaSurveysClaimRewardEnable",
        ["requestType"]: "Study",
      });
    } else if (location.pathname.includes("/bonus")) {
      if (bonusDetails) {
        setFormState({
          ...formState,
          ["points"]: bonusDetails?.data?.isActive ? bonusDetails?.data?.points : 0,
          ["email"]: auth.email,
          ["service"]: "isZampliaSurveysBonusClaimRewardEnable",
          ["requestType"]: "Bonus",
        });
      }
      if (walletDetails && bonusDetails) {
        setShowButton(walletDetails?.userWalletPoints >= Number(bonusDetails?.data?.target_points));
      }
    } else {
      navigate(0);
    }
  }, [location, bonusDetails]);

  useEffect(() => {
    if (location.pathname.includes("/study") && +PointDisplay) {
      setFormState({
        ...formState,
        ["points"]: +PointDisplay,
        ["service"]: "isZampliaSurveysClaimRewardEnable",
        ["requestType"]: "Study",
      });
    }
  }, [location, +PointDisplay]);

  const validation = (formValues: FormState) => {
    setFormState((old: ClaimDataType) => {
      return {
        ...old,
        errors: { ...old.errors, neoBrands: "", points: "", email: "", mobile: "" },
      };
    });

    if (!formValues.neoBrands || formValues.neoBrands === "Select") {
      setFormState((old) => {
        return {
          ...old,
          errors: { ...old.errors, neoBrands: t("page.referral.field") },
        };
      });
      return false;
    }

    if (
      !skipPointsValidationPanelList.includes(auth.panelistId.toString()) &&
      (formValues.points <= (location.pathname.includes("/bonus") ? 149 : 299) ||
        formValues.points >= (location.pathname.includes("/bonus") ? 501 : 3001))
    ) {
      setFormState((old: ClaimDataType) => {
        return {
          ...old,
          errors: { ...old.errors, points: t("page.referral.points") },
        };
      });
      return false;
    }

    // email validation patterns
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!(formValues.email && regexEmail.test(formValues.email))) {
      setFormState((old) => {
        return { ...old, errors: { ...old.errors, email: t("page.referral.valid") } };
      });
      return false;
    }
    if (!formValues.mobile) {
      setFormState((old: ClaimDataType) => {
        return { ...old, errors: { ...old.errors, mobile: t("page.referral.required") } };
      });
      return false;
    }
    if (!isOtpConsentChecked) {
      Modal.error({
        title: "Consent Required",
        content: "Please agree to receive SMS OTP to proceed.",
      });
      return false;
    }
    return true;
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement | HTMLSelectElement> = (e) => {
    e.preventDefault();
    const valid = validation(formState);
    if (valid) {
      postQuery.mutate();
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormState({ ...formState, [event.target.name]: event.target.value });
    setFormState((old) => {
      return {
        ...old,
        errors: { ...old.errors, [event.target.name]: "" },
      };
    });
  };

  const setMobile = (e) => {
    setFormState({ ...formState, ["mobile"]: e });
    setFormState((old) => {
      return {
        ...old,
        errors: { ...old.errors, ["mobile"]: "" },
      };
    });
  };
  const getData = async () => {
    const ipUrl = `/api/user/get-ip-details`;
    const ipResponse = await axiosClient.get(ipUrl, { timeout: 5000, });
    if (ipResponse?.data?.data?.country?.currency?.code === "USD") {
      setCountry("USD");
    } else if (ipResponse?.data?.data?.country?.currency?.code === "CAD") {
      setCountry("CAD");
    } else if (ipResponse?.data?.data?.country?.currency?.code === "AUD") {
      setCountry("AUD");
    } else if (ipResponse?.data?.data?.country?.currency?.code === "INR") {
      setCountry("INR");
    } else {
      setCountry(ipResponse?.data?.data?.country?.currency?.code);
    }
    if (ipResponse?.data?.data?.country?.currency?.code) {
      setCountryCode(ipResponse?.data?.data?.country?.currency?.code);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const input = document.getElementById("points");
    const disableScroll = (e) => {
      e.preventDefault();
    };

    input.addEventListener("wheel", disableScroll);
    return () => {
      input.removeEventListener("wheel", disableScroll);
    };
  }, []);

  const handleShowMore = () => {
    setShowAll(true);
  };

  const handleShowLess = () => {
    setShowAll(false);
  };

  const hiddenBrands = ["PayPal $1-$1000", "Venmo", "Litecoin $10-$1000"];

  const isBonusRoute = location.pathname.includes("/bonus");
  const isFixedPoints = formState.requestType === "Study" || formState.requestType === "Bonus";
  const displayedPoints = isFixedPoints ? (+PointDisplay ? +PointDisplay : 0) : formState.points || 0;
  const selectedBrand = getNeoBrandsData.data?.brands?.find(
    (item) => String(item.id) === String(formState.neoBrands)
  );

  return (
    <LoadingOverlay
      styles={{
        overlay: (base) => ({
          ...base,
          position: "fixed",
          background: "rgb(var(--zs-overlay) / 0.45)",
        }),
      }}
      active={getNeoBrandsData.isLoading || postQuery.isLoading}
      spinner
      text={t("claim.card.Loading")}
    >
      <form
        method="post"
        id="claimRewardFirstStep"
        className="grid items-start grid-cols-1 gap-4 lg:grid-cols-[minmax(0,1fr)_300px]"
        onSubmit={handleSubmit}
      >
        <div className="flex flex-col min-w-0 gap-4">
          <RedeemBrandStep
            brands={getNeoBrandsData.data?.brands}
            country={country}
            pointDisplay={PointDisplay}
            hiddenBrands={hiddenBrands}
            showAll={showAll}
            selectedBrand={formState.neoBrands}
            error={formState.errors.neoBrands}
            isLoading={getNeoBrandsData.isLoading}
            giftcardIcon={Giftcard}
            onChange={handleChange}
            onShowMore={handleShowMore}
            onShowLess={handleShowLess}
          />
          <RedeemDetailsStep
            formState={formState}
            pointDisplay={PointDisplay}
            isBonusRoute={isBonusRoute}
            countryCode={countryCode}
            isOtpConsentChecked={isOtpConsentChecked}
            onConsentChange={() => setIsOtpConsentChecked(!isOtpConsentChecked)}
            onChange={handleChange}
            onMobileChange={setMobile}
          />
        </div>

        <aside className="zs-card lg:sticky lg:top-[calc(var(--zs-topbar-h)+16px)]">
          <div className="zs-card-header">
            <h2 className="zs-card-title">Claim Your Reward</h2>
          </div>
          <div className="flex flex-col gap-4 zs-card-body">
            <div>
              <p className="zs-stat-label">{t("page.referral.Points1")}</p>
              <p className="mt-1 zs-stat-value">{displayedPoints}</p>
            </div>
            <dl className="flex flex-col gap-2.5 pt-4 text-sm border-t border-line">
              <div className="flex items-center justify-between gap-3">
                <dt className="text-ink-3">Reward</dt>
                <dd className="font-medium text-right truncate text-ink">
                  {selectedBrand ? selectedBrand.name : "Not selected"}
                </dd>
              </div>
              <div className="flex items-center justify-between gap-3">
                <dt className="text-ink-3">Type</dt>
                <dd className="font-medium text-ink">Gift Cards</dd>
              </div>
            </dl>
            <div className="form-group">
              <button
                type="submit"
                disabled={!showButton}
                className="capitalize zs-btn zs-btn-primary zs-btn-lg zs-btn-block"
                title={!showButton ? "You don't have enough points" : ""}
              >
                continue
                <FiArrowRight />
              </button>
            </div>
            <p className="flex items-start gap-2 text-xs leading-relaxed text-ink-3">
              <FiShield className="mt-0.5 shrink-0" />
              <span>Next, enter the one-time codes sent to your email and phone to confirm this request.</span>
            </p>
          </div>
        </aside>
      </form>
    </LoadingOverlay>
  );
};
